module.exports = __webpack_public_path__ + "static/collaboration-section-report-a1ab2b083281c9ba2465ce60afaeac54.png";